//
import {
  TIPOS_PAGAMENTO,
  TIPO_PAGAMENTO_CARTAO,
  TIPO_PAGAMENTO_DINHEIRO
} from '../../shared/constants';
import React, { useEffect } from 'react';
import { Dimensions, StyleSheet, View } from 'react-native';
import colors from '../../colors';
import { TXT_M } from '../../constants';
import { useEmpresa } from '../../redux/empresa/empresaHooks';
import { useSessao } from '../../redux/sessao/sessaoHooks';
import CTextInput from '../Generic/CTextInput';
import { CustomPicker } from '../Generic/CustomPicker';
import Divider from '../Generic/Divider';
import Title from '../Generic/Title';

const DEVICE_WIDTH = Dimensions.get('window').width;

type Props = {
  tipoPagamento: string;
  setTipoPagamento: (x: string) => void;
  trocoPara: number;
  setTrocoPara: (x: number) => void;
};

const SelecaoTipoPagamento: React.FC<Props> = (props) => {
  const { tipoPagamento, setTipoPagamento, trocoPara, setTrocoPara } = props;
  const [sessao] = useSessao();
  const [empresa] = useEmpresa();

  useEffect(() => {
    if (trocoPara === undefined) {
      setTrocoPara(0);
    }
  }, [trocoPara]);

  if (!sessao.token) {
    return null;
  }

  return (
    <View>
      <Title style={{ marginBottom: 10 }}>Pagamento:</Title>

      <CustomPicker
        title={'Pagamento:'}
        list={TIPOS_PAGAMENTO}
        getItemLabel={(comanda) => comanda.label}
        getItemValue={(comanda) => comanda.id}
        onChange={(tipo) => {
          console.log('tipo', tipo);

          if (tipo) setTipoPagamento(tipo.id);
        }}
        value={tipoPagamento}
        hideProcurar
      />

      {tipoPagamento === TIPO_PAGAMENTO_DINHEIRO && (
        <CTextInput
          style={{ marginTop: 15 }}
          label={'Troco para:'}
          value={`R$ ${trocoPara?.toString()}`}
          onChangeText={(txt) => {
            if (!txt) {
              txt = '0';
            }
            // let number = txt.replace(/[^0-9,]/g, '');
            let number = txt.replace(/[^0-9]/g, '');
            if (!number) {
              number = '0';
            }
            console.log('number', number);

            setTrocoPara(parseFloat(number));
          }}
          keyboardType="number-pad"
        />
      )}

      <Divider style={{ marginBottom: 10, marginTop: 10 }} />
    </View>
  );
};

const styles = StyleSheet.create({
  radioLabel: {
    fontSize: TXT_M,
    color: colors.darkGrey
  },
  viewTaxa: {
    flexDirection: 'row',
    alignSelf: 'center',
    marginTop: 15,
    justifyContent: 'center',
    alignItems: 'center'
  },
  labelTaxa: { marginRight: 5, fontSize: TXT_M, color: colors.primary },
  valorTaxa: { fontSize: TXT_M, color: colors.values },
  selectView: {
    borderWidth: 2,
    borderColor: colors.lightGrey,
    borderRadius: 5
  },
  select: {
    borderWidth: 0,
    padding: 5
    // backgroundColor: '#ff0'
    // WebkitAppearance: 'none',
    // '-moz-appearance': none,
    // textIndent: 1
    // // text-overflow: '',
  }
});

export default SelecaoTipoPagamento;
